import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=2f23ed75"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=2f23ed75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports